import React from "react";
import { View, Text, Image } from "react-native";
import { Button, Surface } from "react-native-paper";
import { ids, styles } from "./HomeCss.js";
import { Link, useNavigation } from "@react-navigation/native";
import logo from "../../../assets/landingPage/landingLogo.png";
import { whiteColor } from "../../constant/constantCss.js";
import CarousalView from "./CarousalView.jsx";

const HomeScreen = () => {
  const navigation = useNavigation();
  const onClick = () => {
    navigation.navigate("Login");
  };
  return (
    <View style={styles.imageContainer}>
      {/* Carousal */}
      <CarousalView />

      {/* app-bar */}
      <Surface
        style={styles.navBarContainer}
        dataSet={{ media: ids.navBarContainer }}
      >
        <View style={styles.flexRow} elevation={1}>
          <Link
            to={{
              screen: "About Us",
            }}
          >
            <Text style={{ fontSize: 18 }}>About Us</Text>
          </Link>
        </View>
      </Surface>
      {/* explore */}
      <View style={styles.container} dataSet={{ media: ids.container }}>
        <Image
          style={styles.image}
          source={logo}
          dataSet={{ media: ids.image }}
        />
        <Button
          style={styles.button}
          dataSet={{ media: ids.button }}
          mode="outlined"
          textColor={whiteColor}
          onPress={onClick}
          labelStyle={{ fontSize: 18 }}
        >
          Explore
        </Button>
      </View>
    </View>
  );
};

export default HomeScreen;
